import { useState } from 'react';
import { Banner } from 'foundations-components/transitional/components/Banner';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HsfxReminderBanner = ({
  discount
}) => {
  const {
    trackUserInteraction
  } = useTracker();
  const [bannerActive, setBannerActive] = useState(true);
  const PORTAL_ID = PortalIdParser.get();
  const url = `/hsfx-programs/${PORTAL_ID}/startups/eligible/finish?cta=purchase`;
  if (!PORTAL_ID || !discount || !bannerActive) {
    return null;
  }
  return /*#__PURE__*/_jsx(Banner, {
    closeable: true,
    "data-test-id": "hsfx-banner",
    onClose: () => {
      setBannerActive(false);
      try {
        window.sessionStorage.setItem('hsfx.reminder.closed', 'true');
      } catch (e) {
        // no-op
      }
      trackUserInteraction('close reminder banner HSFX');
    },
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "hsfx-banner-text",
      message: "setup-guide-components.hsfxBanner.header",
      options: {
        discount
      }
    }),
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.hsfxBanner.text"
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "hsfx-banner-upgrade",
        href: url,
        marginInlineStart: "600",
        onClick: () => {
          trackUserInteraction('click upgrade to a paid plan HSFX');
        },
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.hsfxBanner.upgrade"
        })
      })]
    })
  });
};
export default HsfxReminderBanner;